import type { PermissionString, RoleType } from '@/types/apps/roleTypes'

// Define subjects
export const SUBJECT_USER_MANAGEMENT = 'User Management'
export const SUBJECT_ROLE_MANAGEMENT = 'Role Management'
export const SUBJECT_OFFICE_MANAGEMENT = 'Office Management'

export const SUBJECT_CONTENT_MANAGEMENT = 'Content Management'
export const SUBJECT_SETTINGS = 'Settings'

// Define actions
export const ACTION_CREATE = 'create'
export const ACTION_READ = 'read'
export const ACTION_UPDATE = 'update'
export const ACTION_DELETE = 'delete'

export const ACTION_PUBLISH = 'publish'
export const ACTION_EDIT = 'edit'
export const ACTION_MANAGE = 'manage'

// Helper function to create permission strings
export const createPermission = (subject: string, action: string): PermissionString => `${subject}:${action}`

// Alternative: Define available permissions config (optional)
export const availablePermissionsConfig = {
  [SUBJECT_USER_MANAGEMENT]: [ACTION_CREATE, ACTION_READ, ACTION_UPDATE, ACTION_DELETE],
  [SUBJECT_ROLE_MANAGEMENT]: [ACTION_CREATE, ACTION_READ, ACTION_UPDATE, ACTION_DELETE],
  [SUBJECT_OFFICE_MANAGEMENT]: [ACTION_CREATE, ACTION_READ, ACTION_UPDATE, ACTION_DELETE],

  [SUBJECT_CONTENT_MANAGEMENT]: [ACTION_PUBLISH, ACTION_EDIT, ACTION_DELETE],
  [SUBJECT_SETTINGS]: [ACTION_MANAGE]
}

// Alternative: Convert config to a flat list of PermissionString (optional)
export const allPossiblePermissions: PermissionString[] = Object.entries(availablePermissionsConfig).flatMap(
  ([subject, actions]) => actions.map(action => createPermission(subject, action))
)

// Constructs a set of permissions from provided roles
export function getEffectivePermissions(userRoles: RoleType[] | undefined | null): Set<PermissionString> {
  const effectivePermissions = new Set<PermissionString>()

  if (!userRoles) {
    return effectivePermissions // Return empty set if roles are null/undefined
  }

  for (const role of userRoles) {
    if (role.permissions) {
      for (const permission of role.permissions) {
        effectivePermissions.add(permission)
      }
    }
  }

  return effectivePermissions
}
